import assert from 'assert';

export const getValueFromJSON = (jsn: any, key: string): any => {
    if (!key)
    {
        return jsn;
    }
    let parseData = key.split('.');
    let currentKey = parseData[0];
    if (!jsn || !jsn.hasOwnProperty(currentKey))
    {
        return null;
    }

    if (parseData.length === 1)
    {
        return jsn[currentKey];
    }

    parseData.shift();
    return getValueFromJSON(jsn[currentKey], parseData.join('.'))
};

export const setValueInJSON = (jsn: any, key: string, value: any) : any => {
    if (!key)
    {
        return;
    }
    let parseData = key.split('.');
    let currentKey = parseData[0];
    let nextKey = parseData[1];
    let isArray = parseInt(nextKey, 10).toString() === nextKey;

    if (!jsn.hasOwnProperty(currentKey) || jsn[currentKey] === undefined)
    {
        if (isArray)
        {
            jsn[currentKey] = [];
        }
        else
        {
            jsn[currentKey] = {};
        }
    }

    if (parseData.length === 1)
    {
        return jsn[currentKey] = value;
    }

    parseData.shift();
    return setValueInJSON(jsn[currentKey], parseData.join('.'), value)
};

export const deleteKeyInJSON = (jsn: any, key: string):any => {
    if (!key)
        return;

    let parseData = key.split('.');
    let currentKey = parseData[0];
    let nextKey: any = parseData[1];
    let isArray = parseInt(nextKey, 10) == nextKey && parseInt(nextKey, 10) >= 0;

    if (!jsn?.hasOwnProperty(currentKey)) {
        if (isArray)
            jsn[currentKey] = [];
        else
            jsn[currentKey] = {};
    }

    if (parseData.length === 1)
        return delete jsn[currentKey];

    parseData.shift();
    return deleteKeyInJSON(jsn[currentKey], parseData.join('.'))
};

export const flatObject = (data : {obj: any, path? : string, result?: any, ignoreFieldsList?: string[]}): any => {
    let {obj, path, result = {}, ignoreFieldsList = []} = data;
    Object.keys(obj).forEach(key =>{
        if (obj[key] instanceof Object && !ignoreFieldsList.includes(key)){
            result = Object.assign(result, flatObject({obj: obj[key], path: [path, key].filter(item => item).join("."), result, ignoreFieldsList}))
        }
        else {
            result[[path, key].filter(item => item).join(".")] = obj[key];
        }
    });
    return result
};

export const valueExtractor = async (data: {form: any, default_value?: any, options? : {noValidate? : boolean}, onFormValidationError?: any}) => {
    const {form, default_value, options = {}, onFormValidationError = (e: any)=>{console.error("form validator error", e)}} = data;
    if (!options.noValidate) {
        try {
            await form.validateFields();
        }
        catch(e) {
            console.error(e)
            onFormValidationError(e)
            return null
        }
    }

    let form_data = form.getFieldsValue();

    let result = {};

    const copyValue = (obj: any, path : any[]) => {
        if (obj instanceof Object && (obj._isADayJsObject || obj.$isDayjsObject)) { //TODO
            return setValueInJSON(result, path.join("."), obj)
        }
        else if(obj instanceof Array){
            for(let i = 0; i < obj.length; i++) {
                obj[i] = copyValue(obj[i], [...path, i])
            }
            return setValueInJSON(result, path.join("."), obj)
        }
        else if (obj instanceof Object) {
            Object.keys(obj).forEach(key => {
                let value = copyValue(obj[key], [...path, key])
                if(value !== undefined) {
                    obj[key] = value
                }
            });

            if(Object.keys(obj).every(key => obj[key] === null)) {
                setValueInJSON(result, [...path].join("."), null)
                return null
            }
            else {
                return obj
            }
        }
        else if (obj !== undefined /*obj || obj === false || obj === 0 || obj === ""*/) {
            if (!default_value || getValueFromJSON(default_value, path.join(".")) !== obj)
                return setValueInJSON(result, path.join("."), obj)
        }

        return null
    }

    copyValue(form_data, [])

    // Object.keys(form_data).forEach(key => {
    //     let value = form_data[key];
    //     if (value || value === false || value === 0) {
    //         if (!default_value || getValueFromJSON(default_value, key) !== value)
    //             setValueInJSON(result, key, value)
    //     }
    // });
    return result;
};

const cleanObj =( obj:any)  => {
    if (!(obj instanceof Object))
        return obj;

    if(obj instanceof Array)
        obj = obj.map(it => cleanObj(it))
    else
        Object.keys(obj).forEach(key => {
            if (obj[key] === null || obj[key] === undefined)
                delete obj[key]
        })

    return obj
}

export const getChangedValues = (new_data: any, old_data: any, ignoreAndAddFieldsList: string[], ignoreFieldsList?: string[]) => {
    let data = Object.keys(new_data).reduce((res, key: string) => {
        let new_value = new_data[key];
        let old_value = getValueFromJSON(old_data, key);
        if ((ignoreAndAddFieldsList || []).includes(key)) {
            setValueInJSON(res, key, new_value)
        }
        if ((ignoreFieldsList || []).includes(key)) {
            return res
        }
        else {
            if (new_value instanceof Object) {
                try {
                    assert.deepStrictEqual(cleanObj(new_value), cleanObj(old_value))
                }catch(e){
                    setValueInJSON(res, key, new_value)
                }
            }
            else if (new_value !== old_value)
                setValueInJSON(res, key, new_value)
        }

        return res;
    }, {});

    return Object.keys(data).length ? data : null
};

export const cleanValue = (data: any) => {
    Object.keys(data).forEach(key => {
        if(data[key] === null)
            delete data[key]
        else if(data[key] instanceof Array) {
            for(let i = 0; i < data[key].length; i++) {
                if(data[key][i] instanceof Object)
                    data[key][i] = cleanValue(data[key])[i]
            }
        }
        else if(data[key] instanceof Object) {
            data[key] = cleanValue(data[key])
        }
    })

    return data

};

export const getFormValue = async (form: any, options = {}) => {
    let form_data: any = await valueExtractor({form, options});
    if (!form_data)
        return null;

    let data = Object.keys(form_data).reduce((res, key) => {
        if (form_data.hasOwnProperty(key)) {
            setValueInJSON(res, key, form_data[key])
        }

        return res;
    }, {});

    return Object.keys(data).length ? data : null
};

export const prepareFormData  = (item: any, path: (string|number)[]) => {

    if (!item)
        return [];

    if(item instanceof Object && !(item instanceof Array) && item.constructor?.name !== "Object") {
        return [{name: path, value: item}]
    }

    return Object.entries(item).reduce((res: any[], data: any) => {
        let key = Number(data[0])
        if(!key && key !== 0)
            key = data[0]
        
        if(data[1] instanceof Object && !(data[1] instanceof Array) && data[1]?.constructor?.name === "Object") {
            res = [...res, ...prepareFormData(data[1], [...path, key])]
        }
        else if(data[1] instanceof Array) {
            if(!(data[1][0] instanceof Object))
                res.push({name: [...path, key], value: data[1], touched: false})
            else{
                res.push({name: [...path, key], value: data[1], touched: false}) //todo tree control issue on first loading
                // for(let i = 0; i < data[1].length; i++){
                //     res = [...res, ...prepareFormData(data[1][i], [...path,key, i])]
                // }
            }
        }
        else {
            res.push({name: [...path, key], value: data[1], touched: false})
        }
        return res
    }, [])
}

export const isFieldConfigEqual = (oldValue:any, newValue: any): boolean => {
    if ((oldValue && !newValue) || (newValue && !oldValue))
        return false

    if (typeof oldValue !== typeof newValue)
        return false

    if(newValue instanceof Array) {
        return newValue.length === oldValue?.length && newValue.every((it, index) => isFieldConfigEqual(oldValue[index], it))
    }
    else if(newValue instanceof Object) {
        return Object.keys(newValue).every(key => isFieldConfigEqual(oldValue[key], newValue[key]))
    }

    return newValue === oldValue
}

export const mergeFieldConfigValue = (oldValue:any, newValue: any, path?: string[]): any => {
    if(newValue instanceof Array) {
        newValue.forEach((val, index) => {
            mergeFieldConfigValue(oldValue, val, [...path || [], index.toString()])
        })
        let merged = getValueFromJSON(oldValue, (path || []).join("."))
        merged = (merged || []).slice(0, newValue.length)
        setValueInJSON(oldValue, (path || []).join("."), merged)
        return oldValue
    }
    else if(newValue instanceof Object && newValue.constructor?.name === "Object") {
        Object.keys(newValue).forEach(key => {
            mergeFieldConfigValue(oldValue, newValue[key], [...path || [], key])
        })
        return oldValue
    }
    else if(newValue instanceof Object && newValue.constructor?.name !== "Object") {
        setValueInJSON(oldValue, (path || []).join("."), newValue)
        return newValue
    }

    if (newValue === null){
        deleteKeyInJSON(oldValue, (path || []).join("."))
    }
    else{
        setValueInJSON(oldValue, (path || []).join("."), newValue)
    }

    return oldValue
}
